<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="900" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ $t('global.menu.backoffice.linkShopWithAreas', { shop: formData?.name }) }}
            </h3>
        </template>

        <template #default>

            <v-row class="shop-info-container">
                <v-col cols="12">
                    <v-chip-group v-if="type == 'shop' && formData.areasData.length" multiple column>
                        <v-chip v-for="data in formData.areasData" size="small" :key="data.id" closable
                            @click:close="removeSelection(data.id)">
                            {{ data.properties[`name${selectedLanguage.toUpperCase()}`] }}
                        </v-chip>
                    </v-chip-group>
                    <v-chip-group v-else-if="type == 'productCategory' && formData.areasData.length" multiple column>
                        <v-chip v-for="data in formData.areas" size="small" :key="data.id" closable
                            @click:close="removeSelection(data.id)">
                            {{ data.properties[`name${selectedLanguage.toUpperCase()}`] }}
                        </v-chip>
                    </v-chip-group>
                </v-col>

                <v-col md="12">
                    <v-text-field v-model="search" label="Search location" density="compact" hide-details="true"
                        variant="outlined" clearable></v-text-field>
                </v-col>

                <template v-for="(column, index) in [0, 1]" :key="index">
                    <v-col cols="12" md="6">
                        <v-list v-model:selected="formData.areaIds" multiple select-strategy="leaf" density="compact">
                            <v-list-group v-for="country in splitItems[index]" :key="country.id" density="compact">
                                <template v-slot:activator="{ props }">
                                    <v-list-item v-bind="props" density="compact"
                                        :class="{ 'highlighted-country bg-default': isCountrySelected(country) }">
                                        {{ country.nameTranslations[`name${selectedLanguage.toUpperCase()}`] }}

                                        <v-chip v-if="getSelectedCount(country) > 0" color="black" size="x-small" label
                                            class="ml-2">
                                            {{ getSelectedCount(country) }}
                                        </v-chip>
                                    </v-list-item>
                                </template>

                                <v-list-item v-for="area in country.children" :key="area.id" density="compact"
                                    :value="type == 'shop' ? area.id : area.identifier">
                                    <template v-slot:prepend="{ isSelected }">
                                        <v-list-item-action start>
                                            <v-checkbox :model-value="isSelected" density="compact"
                                                hide-details="true"></v-checkbox>
                                        </v-list-item-action>
                                    </template>
                                    {{ area.properties[`name${selectedLanguage.toUpperCase()}`] }}
                                </v-list-item>
                            </v-list-group>
                        </v-list>
                    </v-col>
                </template>
            </v-row>

            <!-- <v-treeview v-model="selectedLocations" :items="items" item-value="id" 
                        selectable open-on-click density="compact" :lines="false" @update:selected="add">
                        <template v-slot:title="{ item }">
                            {{ item.nameTranslations ? item.nameTranslations[`name${selectedLanguage.toUpperCase()}`] :
                                item.properties[`name${selectedLanguage.toUpperCase()}`] }}
                                {{ item.id }}
                        </template>
                    </v-treeview> -->


        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="save">{{ $t('global.form.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "CreateLabelDialog",
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import LabelCategories from '../LabelCategories.vue';


const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({ translations: {} }) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
const props = defineProps({
    save: Function, // Define prop as a function
    items: Array,
    type: String
});
const parent = ref(null)
const search = ref('')
const selectedCountry = ref({ children: [] })
const selectedLocations = ref([]);

const isCountrySelected = (country) => {
    return country.children.some(area => formData.value.areaIds?.includes(area.id));
}

const getSelectedCount = (country) => {
    return country.children.filter(area => formData.value.areaIds?.includes(area.id)).length;
}


// const loadChildren = async (item) => {
//   if (item.children?.length) return; // Prevent reloading if already set

//   // Simulate delay (if needed)
//   await new Promise(resolve => setTimeout(resolve, 300));

//   // Find preloaded data and attach it dynamically
//   item.children = item.preloadedChildren || [];
// };
const add = (item) => {
    selectedLocations.value.push(item[0]);
}

watch(
    () => formData.value.areaIds,
    (newVal) => {
        if (!newVal) return;

        // Flatten all areas from countries
        const allAreas = props.items.flatMap(country => country.children || []);

        // Find selected area objects
        formData.value.areasData = newVal.map(id => allAreas.find(area => area.id === id)).filter(Boolean);
    },
    { deep: true }
);

watch(() => selectedLocations.value, (selectedNodes) => {
    // Ensure `areaIds` only contains IDs from `areasData`
    console.log('selectedNodes', selectedNodes);
    formData.areasData = selectedNodes.map(node => node);
}, { deep: true });

// Compute filtered data dynamically
const splitItems = computed(() => {
    const midpoint = Math.ceil(filteredCountries.value.length / 2);
    return [filteredCountries.value.slice(0, midpoint), filteredCountries.value.slice(midpoint)];
});

const filteredCountries = computed(() => {
    if (!search.value) return props.items; // If no search, return all countries

    return props.items
        .map((country) => {
            const countryMatches = country.nameTranslations[`name${selectedLanguage.toUpperCase()}`]
                ?.toLowerCase()
                ?.includes(search.value.toLowerCase());

            const matchingAreas = country.children.filter(area =>
                area.properties[`name${selectedLanguage.toUpperCase()}`]
                    ?.toLowerCase()
                    ?.includes(search.value.toLowerCase())
            );

            if (countryMatches || matchingAreas.length) {
                return {
                    ...country,
                    children: countryMatches ? country.children : matchingAreas, // Show full country if it matches
                };
            }

            return null;
        })
        .filter(Boolean); // Remove null values
});

const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = {
        translations: { DE: { value: '' }, EN: { value: '' } },
        areasData: [] // Ensure areasData is always an array
    };
};
onMounted(() => {

});
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}

.highlighted-country {
    font-weight: 800;
}
</style>
